// src/components/admin/AdminTabs.js
import React from 'react';
import { Tabs } from 'react-bootstrap';
import './AdminTabs.css';

const AdminTabs = ({ activeKey, onSelect, children }) => {
  return (
    <div className="admin-tabs">
      <Tabs
        id="admin-tabs"
        activeKey={activeKey}
        onSelect={onSelect}
        className="mb-4"
      >
        {children}
      </Tabs>
    </div>
  );
};

export default AdminTabs;